import React from 'react';
import { Box, Typography } from '@mui/material';
import { Order } from '@m4a3/api-client';
import { LoadingSpinner } from '../../../components/LoadingSpinner/LoadingSpinner';
import { isLoadingOrder, shouldLoadOrderNow, isWaitingForMCToApproveLoad } from '../../../utils/orderUtils';

export const LoadingProgressText = (props: {
  order: Order
}) => {
  const getLoadingProgressString = (): string => {
    if (shouldLoadOrderNow(props?.order)) {
      return 'Waiting for support to load';
    } else if (isLoadingOrder(props?.order)) {
      return 'Loading into drone'
    }
    return '';
  };

  if (isWaitingForMCToApproveLoad(props?.order)) {
    return <></>
  }
  return (
    <Box
      display={'flex'}
      alignItems="left"
      sx={{
        marginTop: 1
      }}>
      <Box
        display={'flex'}>
        <LoadingSpinner size={20} />
      </Box>
      <Typography
        noWrap
        pl={1}
        variant={'body1'}
        sx={{
          color: 'black'
        }}
        style={{ fontWeight: 400, fontSize: 12 }}>
        {getLoadingProgressString()}
      </Typography>
    </Box>
  );
};
